import classNames from "classnames/dedupe";
import React, { FC, ReactNode } from "react";

export interface IBadgeItem {
  text: string | ReactNode;

  /** class name contains backgroung-color */
  color?: string;
}

export interface IBadgeProps extends IBadgeItem {
  /**
   * The custom set of css classes used to style component
   *
   * root: applied to outer div element
   */
  classes?: { root?: string };
}

const Badge: FC<IBadgeProps> = ({ text, color, classes }) => {
  const itemClass = classNames("product-badge", classes?.root, color);

  return (
    <div data-testid="product-badge" className={itemClass}>
      {text}
    </div>
  );
};

export default Badge;
